export default [
  'newTrialCreated'
]
